import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Import translation files
import translationEN from './translations/en.json';
import translationTE from './translations/te.json';
import translationHI from './translations/hi.json';

// Resources object with translations
const resources = {
  en: {
    translation: translationEN
  },
  te: {
    translation: translationTE
  },
  hi: {
    translation: translationHI
  }
};

i18n
  // Load translation using http
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: true,

    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    // Detect language from localStorage or navigator
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    }
  });

export default i18n;